const callNoticesSound = () => {
  window.audio_nt_notice?.play();
};

export default callNoticesSound;
